import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';
import { Container, Grid } from '@mui/material';

import { useTranslate } from '../../hooks/useTranslate';
import { PrimaryIcon } from '../../icons/PrimaryIcon/PrimaryIcon';
import { ExternalLink } from '../ExternalLink/ExternalLink';
import { NewsletterFooter } from '../Newsletter/NewsletterFooter/NewsletterFooter';
import { ProudPartnersCreatorsLogos } from '../ProudPartnersCreatorsLogos/ProudPartnersCreatorsLogos';
import { PaymentLogos } from './components/PaymentLogos/PaymentLogos';
import { TravelAgentItem } from './components/TravelAgentItem/TravelAgentItem';
import {
  ContactInfoList,
  ContactInfoText,
  CookieSettingButton,
  CopyRight,
  IconContainer,
  ListItem,
  LogosWrapperDiv,
} from './Footer.styles';
import type { Props } from './Footer.types';

export const Footer = ({
  isLogoSectionEnabled,
  isNewsletterSectionEnabled,
  footerContent,
  openLinksInNewTab = false,
  paymentMethods,
  proudPartnersCreatorsLogos,
  onAuthClick,
}: Props) => {
  const { t } = useTranslate();
  const year = new Date().getFullYear();

  const showCookiesDialog = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.Osano.cm.showDrawer();
  };

  return (
    <Container
      maxWidth={false}
      component="footer"
      sx={{
        backgroundColor: 'var(--color-white)',
        margin: '0',
        color: 'var(--color-black)',
        py: [3, 6],
        marginTop: 'var(--spacing-48)',
      }}
    >
      {isLogoSectionEnabled && (
        <Grid
          container
          spacing={0}
          alignItems="center"
          direction="column"
          justifyContent="center"
        >
          <IconContainer>
            <PrimaryIcon />
          </IconContainer>
        </Grid>
      )}
      {footerContent && (
        <>
          {footerContent.content.map((footerRow, rowIndex) => (
            <Grid
              container
              spacing={0}
              alignItems="center"
              direction="column"
              justifyContent="center"
              key={`footer-row-${rowIndex}`}
            >
              <ContactInfoList>
                {footerRow.map((item) =>
                  item.href ? (
                    <ListItem key={item.href}>
                      <ExternalLink
                        href={item.href}
                        target={openLinksInNewTab ? '_blank' : '_self'}
                      >
                        {item.text ?? t(item.microcopy)}
                      </ExternalLink>
                    </ListItem>
                  ) : (
                    <ContactInfoText key={item.text ?? item.microcopy}>
                      <span>{item.text ?? t(item.microcopy)}</span>
                    </ContactInfoText>
                  )
                )}
                {rowIndex === 1 && (
                  <TravelAgentItem onAuthClick={onAuthClick} />
                )}
              </ContactInfoList>
            </Grid>
          ))}

          <Grid
            container
            spacing={0}
            alignItems="center"
            direction="column"
            justifyContent="center"
          >
            <CookieSettingButton onClick={showCookiesDialog}>
              <CookieOutlinedIcon /> {t('cookie.footerLinkText')}
            </CookieSettingButton>
          </Grid>
        </>
      )}

      {isNewsletterSectionEnabled && <NewsletterFooter />}

      {(!!paymentMethods?.length || !!proudPartnersCreatorsLogos?.length) && (
        <LogosWrapperDiv>
          {paymentMethods && <PaymentLogos methods={paymentMethods} />}
          {!!proudPartnersCreatorsLogos?.length && (
            <ProudPartnersCreatorsLogos
              proudPartners={proudPartnersCreatorsLogos}
            />
          )}
        </LogosWrapperDiv>
      )}

      <Grid
        container
        spacing={0}
        alignItems="center"
        direction="column"
        justifyContent="center"
      >
        <CopyRight>&copy; {year} Stena Line Travel Group AB</CopyRight>
      </Grid>
    </Container>
  );
};
